import PropTypes from 'prop-types'
import {
  Page,
  Container,
  ContentHeader,
  Permitted,
  MenuButton,
} from 'components'

import { RemoveSegment } from './components'

import { useFetch } from 'hooks'
import * as service from 'service'

import constants from 'constants/index'

import { SegmentsForm } from './components'

const SegmentsEdit = ({ match }) => {
  const {
    params: { segmentId },
  } = match

  const { response, isLoading, refresh } = useFetch(
    service.dponet.segments.show,
    {
      segmentId,
    },
    [segmentId],
  )

  return (
    <Page title="Edição de segmento">
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Edição"
          menu="Segmento"
          subtitle="Edição de segmento"
        >
          <Permitted someTags={[constants.permissions.SEGMENTS.DESTROY]}>
            <MenuButton>
              <RemoveSegment
                isEdit
                segmentId={response?.data?.segment?.id}
                refresh={refresh}
              />
            </MenuButton>
          </Permitted>
        </ContentHeader>
        {!isLoading && (
          <SegmentsForm isEdit segment={response?.data?.segment} />
        )}
      </Container>
    </Page>
  )
}

SegmentsEdit.propTypes = {
  match: PropTypes.object,
}

export default SegmentsEdit
